// webFetchTool.js — F13-E7-T10: web de VERDADE pro agente. WSX (forense Pro Esporte):
// reverte a exclusividade do chat (#431) — o agente do CODE também tem web agora.
//
// A constituição de chat prometia "web" e o composer oferece Deep Research, mas
// não existia tool de web — informação atual era estruturalmente inentregável.
// Esta tool chama o Worker POST /api/web-fetch (fetchSource dos agentes
// agendados: SSRF-guard com redirects re-validados, corpo capado, texto
// extraído). WSX: uma tarefa de SEO no Code precisava buscar um site AO VIVO; sem
// web, o agente caía em `curl … | python3` — bloqueado pelo guard de código remoto
// (commandSafetyExtra) — e travava. Agora o Code tem a saída legítima, read-only.

import { apiFetch } from './api.js';

export const WEB_FETCH_DEF = {
  type: 'function',
  function: {
    name: 'web_fetch',
    description:
      'Busca UMA página web (server-side, com guarda anti-SSRF) e devolve o TEXTO extraído (até ~6k chars). '
      + 'Use quando a resposta depende de informação ATUAL ou externa (docs de lib, notícia, preço, release notes) — '
      + 'seu conhecimento tem data de corte. NÃO use pra conteúdo que você já sabe. '
      + 'Query com o ano CORRENTE quando datar ("release notes vite 2026", não 2024). Ex: {"url":"https://vitejs.dev/blog"}.',
    parameters: {
      type: 'object',
      properties: {
        url: { type: 'string', description: 'URL http(s) completa da página' },
      },
      required: ['url'],
    },
  },
};

/** Executa a busca via Worker; devolve string modelo-facing (nunca lança). */
export async function executeWebFetch(args) {
  const url = typeof args?.url === 'string' ? args.url.trim() : '';
  if (!url) return 'Erro: web_fetch exige {"url":"https://..."} não vazia.';
  const res = await apiFetch('/api/web-fetch', { method: 'POST', body: { url } });
  if (!res.ok) return `Erro: web_fetch falhou (${res.error || 'rede/auth'}).`;
  const d = res.data || {};
  if (!d.ok) return `Erro: não consegui buscar ${url} (${d.error || 'bloqueada ou indisponível'}).`;
  return `[web_fetch ${d.url}]\n${d.text || '(página sem texto extraível)'}`;
}

/** extraTool web_fetch: disponível em QUALQUER sessão local (chat E code). WSX — reverte
 * a exclusividade do chat (#431). Read-only (sem gate de aprovação), guarda anti-SSRF
 * no Worker. O param legado é ignorado (mantido só p/ compat de chamada). */
export function resolveWebFetchTools() {
  return [{
    def: WEB_FETCH_DEF,
    execute: (args) => executeWebFetch(args),
  }];
}
